import React, {Component, Fragment} from 'react';
import './App.css';
import Sidebar from './Sidebar';
import Page from './Page';
import logo from './Header/logo_bar.png';

import { Layout, Icon, Menu } from 'antd';
import { inject, observer } from 'mobx-react';
import {withRouter, Link, Redirect} from 'react-router-dom';
import {QsHelper} from "../../helpers";

//NOTE: I added @withRouter decorator because --> https://github.com/mobxjs/mobx-react/issues/210

@withRouter
@inject('profileStore', 'authStore', 'translationsStore')
@observer
class App extends Component {
  constructor(props) {
    super(props);
    if (!this.props.authStore.justLoggedIn) {
      this.props.authStore.setJustLoggedIn(false);
      this.props.profileStore.pullUser();
    }

    this.state = {
      collapsed: false
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };

  render() {

    if (window.parent !== window) {
      // INFO: for zuora callback path /process-zuora It check if it is an iframe to avoid rendering the entire app inside the iframe
      return <Page />;
    }

    return (
      <Layout style={{ minHeight: '100%' }} className="App">
        <Layout.Sider className="app-sider" trigger={null} collapsible collapsed={this.state.collapsed} width={200}>
          <div className="logo">
            <img src={logo} alt="Air" />
            <div className="label">{this.props.translationsStore.current['index']['header']}</div>
          </div>
          <Sidebar collapsed={this.state.collapsed} />
        </Layout.Sider>

        <Layout>
          <Layout.Header className="app-header">
            <Icon className="trigger" type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'} onClick={this.toggle} />

            <Menu mode="horizontal">
              <Menu.SubMenu title={<Icon className="menu-user" type="user" />}>
                <Menu.Item key="setting:0">{this.props.profileStore.profile && <span>{this.props.profileStore.profile.email}</span>}</Menu.Item>
                <Menu.Item key="setting:1">
                  <Link className="logout" to="/logout">
                    <Icon type="poweroff" />
                    {this.props.translationsStore.current['index']['btnLogout']}
                  </Link>
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Layout.Header>
          <Layout.Content className="contentPage">
            <Page />
          </Layout.Content>
        </Layout>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js